import { motion } from "framer-motion";
import site from "@/data/site.json";

export default function WhatsAppFloat() {
    const href = `https://wa.me/${site.contact.whatsappNumber}?text=${encodeURIComponent(
        "Olá! Vim pelo site do Mimo & Pata (demonstração).",
    )}`;
    return (
        <motion.a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-float-button"
            title="WhatsApp demonstrativo — não envia mensagem real"
            aria-label="Abrir conversa no WhatsApp (demonstrativo)"
            initial={{ opacity: 0, scale: 0, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ delay: 1.6, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.95 }}
            className="fixed bottom-5 right-5 z-30 grid h-14 w-14 place-items-center rounded-full bg-forest text-cream shadow-[0_16px_36px_rgba(23,61,53,0.35)]"
        >
            <span
                className="absolute inset-0 animate-ping rounded-full bg-forest/40"
                style={{ animationDuration: "2.4s" }}
                aria-hidden="true"
            />
            <svg viewBox="0 0 24 24" className="relative h-6 w-6 fill-current" aria-hidden="true">
                <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.87 9.87 0 0 0 4.79 1.22h.01c5.46 0 9.9-4.45 9.9-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2zm0 18.15h-.01a8.2 8.2 0 0 1-4.18-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.2 8.2 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24 2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.25-.64.8-.78.97-.14.16-.29.18-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.01-.38.11-.51.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.23.25-.87.85-.87 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.6.19 1.14.16 1.57.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.15-1.18-.06-.1-.23-.16-.48-.28z" />
            </svg>
        </motion.a>
    );
}
